import {tokenSenderInterceptorFactory} from './token-sender';
import {unauthorizedInterceptorFactory} from './unauthorized-error';
import {organizationUpdateInterceptorFactory} from './organization-update';
import {localizationInterceptorFactory} from './localization';

const interceptorConfig = ($httpProvider:ng.IHttpProvider) => {
  $httpProvider.interceptors.push(tokenSenderInterceptorFactory);
  $httpProvider.interceptors.push(unauthorizedInterceptorFactory);
  $httpProvider.interceptors.push(organizationUpdateInterceptorFactory);
  $httpProvider.interceptors.push(localizationInterceptorFactory);
};

interceptorConfig.$inject = ['$httpProvider'];

export default angular.module('imomo.auth.interceptor', [])
    .config(interceptorConfig)
    .name;



/** WEBPACK FOOTER **
 ** ./app/auth/interceptor/interceptor.module.ts
 **/